import { useEffect, useRef } from 'react'

// Barras de meses con scroll horizontal: al cargar (o cambiar de mes) centra el botón activo en la
// barra — en móvil se veía "Febrero…Junio" con "Octubre" seleccionado fuera de la vista
// (fix-mobile-responsive). Se ajusta `scrollLeft` del contenedor en vez de usar `scrollIntoView`,
// que además desplazaría la página en vertical.
export function useScrollActiveIntoView<T extends HTMLElement>(selector: string, deps: unknown[]) {
  const ref = useRef<T>(null)

  useEffect(() => {
    const container = ref.current
    const active = container?.querySelector<HTMLElement>(selector)
    if (!container || !active) return
    container.scrollLeft = active.offsetLeft - container.offsetLeft - (container.clientWidth - active.offsetWidth) / 2
  }, deps)

  return ref
}
